<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="检测日期：">
            <el-date-picker size="medium" v-model="searchForm.date" type="date" placeholder="选择日期" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="queryTable()" style="float:right">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="未检测" name="notCheckDoc">
          <V-NotCheckDoc ref="notCheckDoc" :search-form1="searchForm" :current-page1="currentPage" v-if="flag">
          </V-NotCheckDoc>
        </el-tab-pane>
        <el-tab-pane label="已检测" name="haveCheckDoc">
          <V-HaveCheckDoc ref="haveCheckDoc" :search-form1="searchForm" :current-page1="currentPage" v-if="flag">
          </V-HaveCheckDoc>
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>
<script>
import VNotCheckDoc from './notCheckDoc';
import VHaveCheckDoc from './haveCheckDoc';
import { getFormatDay } from '@/assets/common/common';

export default {
  data() {
    return {
      activeName: 'notCheckDoc',
      tabActiveName: sessionStorage.getItem('pesticideResidueDetectionTabActiveName'),
      active: ['notCheckDoc', 'haveCheckDoc'],
      searchForm: {
        date: getFormatDay(1, '-'),
      },
      flag: false,
      tempList: [],
      tempObj: {},
      currentPage1: 1,
      currentPage2: 1,
    };
  },
  components: {
    VNotCheckDoc,
    VHaveCheckDoc,
  },
  created() {
    this.tabActive();
  },
  mounted() {
    this.handleClick();
  },
  computed: {
  },
  methods: {
    handleClick(tab, event) {
      sessionStorage.setItem('pesticideResidueDetectionTabActiveName', this.activeName);
      if (this.activeName == 'notCheckDoc') {
        if (this.SAVE_DSORDER_LIST) {
          this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
          this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
        } else {
          this.currentPage = 1;
        }
        this.flag = true;
        this.$nextTick(async () => {
          await this.$refs.notCheckDoc.queryTable(0);
        });
      } else {
        if (this.SAVE_DSORDER_LIST) {
          this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
          this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
        } else {
          this.currentPage = 1;
        }
        this.flag = true;
        this.$nextTick(async () => {
          await this.$refs.haveCheckDoc.queryTable(0);
        });
      }
    },
    tabActive() {
      const flag = this.active.find((item) => {
        if (this.tabActiveName == item) {
          return true;
        }
      });
      if (flag) {
        this.activeName = this.tabActiveName;
      }
    },
    // 搜索
    queryTable() {
      if (this.activeName == 'notCheckDoc') {
        this.$refs.notCheckDoc.queryTable(0);
      } else {
        this.$refs.haveCheckDoc.queryTable(0);
      }
    },
  },
};
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/foodSecurity/pesticideResidueDetection.vue